<div *ngIf='loaded == 1'>
    <div ngClass.gt-sm="pdt60 pdb40 vh80" ngClass.lt-md="pdt20 pdb40">
        <div class="cw">
            <div fxLayout="row" fxLayoutGap="2rem" fxLayoutAlign="center">

                <!-- Menu izquierda -->
                <div fxLayout="column" fxFlex="25%" fxShow="true" fxShow.lt-md="false">
                    <h6 class="ft17 ft500 mgb20">Bienvenido {{nombre}}</h6>
                    <p>
                        <a (click)="miCuenta=1; historialPagos=0; datosFacturacion=0" class="cursorPointer">
                            <div fxLayout="row" fxLayoutAlign=" center">
                                <mat-icon class="linkIcon ft22 gray-6" [ngClass]=" {'gray-9':miCuenta == 1}">
                                    account_circle
                                </mat-icon>
                                <span class="mgl05" [ngClass]=" {'gray-9 ft500':miCuenta == 1}">Mi cuenta </span>
                            </div>
                        </a>
                    </p>
                    <p>
                        <a (click)="miCuenta=0; historialPagos=1; datosFacturacion=0" class="cursorPointer">
                            <div fxLayout="row" fxLayoutAlign=" center">
                                <mat-icon class="linkIcon ft22 gray-6" [ngClass]=" {'gray-9':historialPagos == 1}">
                                    credit_card </mat-icon>
                                <span class="mgl05" [ngClass]=" {'gray-9 ft500':historialPagos== 1}">Historial de compras
                                </span>
                            </div>
                        </a>
                    </p>
                    <p>
                        <a (click)="miCuenta=0; historialPagos=0; datosFacturacion=1" class="cursorPointer">
                            <div fxLayout="row" fxLayoutAlign=" center">
                                <mat-icon class="linkIcon ft22 gray-6" [ngClass]=" {'gray-9':datosFacturacion == 1}">
                                    attach_money </mat-icon>
                                <span class="mgl05" [ngClass]=" {'gray-9 ft500':datosFacturacion == 1}">Datos de
                                    facturación
                                </span>
                            </div>
                        </a>
                    </p>
                </div> 

                <!-- Mi cuenta  -->
                <div fxLayout="column" fxFlex="50%" fxFlex.lt-md="100%">
                    <div *ngIf="miCuenta===1">
                        <div class="mgb20" *ngIf="usuario.photoURL" fxLayout="column" fxLayoutAlign.lt-md="center center">
                            <img [src]="usuario.photoURL" alt="foto de perfil" class="avatar10">
                                                    <!-- Modificar foto de perfil -->
                        <div class="mgb20" fxShow="lt-md">
                            <a class="blueLink" *ngIf="modificarFoto===0" (click)="modificarFoto = 1"> Modificar foto de
                                perfil
                            </a>
                            <div class="mgt10" *ngIf="modificarFoto === 1">
                                <input class="ft11" type="file" id="file" (change)="onFileSelected($event, 'photoURL')"
                                    name="image" autocomplete="off" />
                                <button (click)="guardarUser()" type="button" class="mgl10 darkButton">Guardar</button>
                                <a class="mgl10 blueLink" *ngIf="modificarFoto===1" (click)="modificarFoto = 0">
                                    Cancelar
                                </a>
                            </div>
                        </div>
                        </div>



                        <form>
                            <div fxLayout="column" class="mgb10">
                                <label>Nombre completo</label>
                                <input [(ngModel)]="usuario.nombreCompleto" [ngModelOptions]="{standalone: true}"
                                    type="text" >
                            </div>

                            <div fxLayout="column" class="mgb10">
                                <label>Email</label>
                                <input type="text" class="form-control-full-width-read-only" readonly
                                    value="{{usuario.email}}">
                            </div>

                            <br>
                            <hr>
                            <h6 class="h6Title">Información profesional</h6>
                            <br>

                            <div fxLayout="column" class="mgb10">
                                <label>Género</label>
                                <select [(ngModel)]='usuario.genero' [ngModelOptions]="{standalone: true}"
                                    >
                                    <option [defaultSelected]=true value=" ">Seleccione su género</option>
                                    <option value="Masculino">Masculino</option>
                                    <option value="Femenino">Femenino</option>
                                </select>
                            </div>

                            <div fxLayout="column" class="mgb10">
                                <label>Año de nacimiento</label>
                                <input [(ngModel)]="usuario.fechaNacimiento"
                                    [ngModelOptions]="{standalone: true}" type="number" min="1940" max="2010" step="1"
                                    value="1990">
                            </div>


                            <div fxLayout="column" class="mgb10">
                                <label>País actual</label>
                                <select [(ngModel)]="usuario.paisActual" [ngModelOptions]="{standalone: true}"
                                    >
                                    <option [defaultSelected]=true value=" ">Seleccione el País</option>
                                    <option value="Antigua y Barbuda">Antigua y Barbuda</option>
                                    <option value="Argentina">Argentina</option>
                                    <option value="Bahamas">Bahamas</option>
                                    <option value="Barbados">Barbados</option>
                                    <option value="Belice">Belice</option>
                                    <option value="Bolivia">Bolivia</option>
                                    <option value="Brasil">Brasil</option>
                                    <option value="Canadá">Canadá</option>
                                    <option value="Chile">Chile</option>
                                    <option value="Colombia">Colombia</option>
                                    <option value="Costa Rica">Costa Rica</option>
                                    <option value="Cuba">Cuba</option>
                                    <option value="Dominica">Dominica</option>
                                    <option value="Ecuador">Ecuador</option>
                                    <option value="El Salvador">El Salvador</option>
                                    <option value="Ecuador">España</option>
                                    <option value="Estados Unidos">Estados Unidos</option>
                                    <option value="Granada">Granada</option>
                                    <option value="Guatemala">Guatemala</option>
                                    <option value="Guyana">Guyana</option>
                                    <option value="Haití">Haití</option>
                                    <option value="Honduras">Honduras</option>
                                    <option value="Jamaica">Jamaica</option>
                                    <option value="México">México</option>
                                    <option value="Nicaragua">Nicaragua</option>
                                    <option value="Panamá">Panamá</option>
                                    <option value="Paraguay">Paraguay</option>
                                    <option value="Perú">Perú</option>
                                    <option value="República Dominicana">República Dominicana</option>
                                    <option value="San Cristóbal y Neives">San Cristóbal y Neives</option>
                                    <option value="San Vicente y las Granadinas">San Vicente y las Granadinas</option>
                                    <option value="Santa Lucía">Santa Lucía</option>
                                    <option value="Surinam">Surinam</option>
                                    <option value="Trinidad y Tobago">Trinidad y Tobago</option>
                                    <option value="Uruguay">Uruguay</option>
                                    <option value="Venezuela">Venezuela</option>   
                                    <option value="Antigua y Barbuda">Otro</option>                                 
                                </select>
                            </div>

                            <div fxLayout="column" class="mgb10">
                                <label>Profesión</label>
                                <input [(ngModel)]="usuario.profesion" [ngModelOptions]="{standalone: true}" type="text"
                                     value=" ">
                            </div>

                            <div fxLayout="column" class="mgb10">
                                <label>Campo o especialización</label>
                                <input [(ngModel)]="usuario.especialidad" [ngModelOptions]="{standalone: true}"
                                    type="text"  value=" ">
                            </div>

                            <div fxLayout="column" class="mgb10">
                                <label>Años de experiencia laboral</label>
                                <select [(ngModel)]="usuario.anosExperiencia" [ngModelOptions]="{standalone: true}"
                                    >
                                    <option [defaultSelected]=true value=" "> </option>
                                    <option value="menos de 1 año">menos de 1 año</option>
                                    <option value="Entre 1 y 5 años">Entre 3 y 5 años</option>
                                    <option value="Entre 5 y 10 años">Entre 5 y 10 años</option>
                                    <option value="Entre 10 y 20 años">Entre 10 y 20 años</option>
                                    <option value="Más de 20 años">Más de 20 años</option>
                                </select>
                            </div>

                            <div fxLayout="column" class="mgb10">
                                <label>Situación laboral</label>
                                <select [(ngModel)]="usuario.situacionLaboral" [ngModelOptions]="{standalone: true}"
                                    >
                                    <option [defaultSelected]=true value=" "> </option>
                                    <option value="Estudiante">Estudiante</option>
                                    <option value="Actualmente laborando">Empleado</option>
                                    <option value="Freelance">Freelance</option>
                                    <option value="En busca de oportunidades">En busca de oportunidades</option>
                                </select>
                            </div>

                            <div fxLayout="column" class="mgb10">
                                <label>Industria</label>
                                <input [(ngModel)]="usuario.industria" [ngModelOptions]="{standalone: true}"
                                    type="text"  value=" ">
                            </div>

                            <div fxLayout="column" class="mgb10">
                                <label>Empleador</label>
                                <input [(ngModel)]="usuario.empleador" [ngModelOptions]="{standalone: true}" type="text"
                                     value=" ">
                            </div>


                            <div fxLayout="column" class="mgb10">
                                <label>Título más alto</label>
                                <select [(ngModel)]="usuario.titulo" [ngModelOptions]="{standalone: true}"
                                    >
                                    <option [defaultSelected]=true value=" "> </option>
                                    <option value="Bachiller">Bachiller</option>
                                    <option value="Técnico">Técnico</option>
                                    <option value="Título universitario">Titulo universitario</option>
                                    <option value="Maestría">Maestría</option>
                                    <option value="Doctorado">Doctorado</option>
                                    <option value="Doctorado">otro</option>
                                </select>
                            </div>

                        </form>

                        <div fxLayout="row" fxLayoutAlign="space-between" class="mgt20">
                            <button (click)="guardarUser()" type="button" class="darkButton">Guardar</button>
                            <!-- Eliminar Cuenta -->
                            <!-- (click)="deleteUser()" -->
                            <!-- <button type="button" class="mgl10 grayButton red-5">Eliminar mi cuenta</button>     -->
                        </div>
                    </div>

                    <!-- Historial de pagos  -->
                    <div *ngIf="historialPagos===1">
                        <historial-compras-estudiante></historial-compras-estudiante>
                    </div>

                    <!-- Historial de Datos de facturacion  -->
                    <div *ngIf="datosFacturacion===1">
                        <datos-facturacion-estudiante></datos-facturacion-estudiante>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<div *ngIf='loaded == 0'>
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>